<template>
    <modal
        v-if="show"
        confirm
        type="is-danger"
        size="is-xsmall"
        submit-text="Delete"
        :title="title"
        :busy="busy"
        :submit-disabled="disabled"
        @submit="handleSubmit"
        @closed="handleClosed(false)"
    >
        Are you sure you want to delete your STIR/SHAKEN registration? This can not be undone.
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    emits: ['closed'],

    data() {
        return {
            loading: true,
            busy: false,
            title: 'Delete STIR/SHAKEN',
        };
    },

    computed: {
        show() {
            return this.showShakenStirDeleteModal;
        },

        titleModal() {
            return `Delete STIR/SHAKEN ${this.item.businessProfile.name}`;
        },

        disabled() {
            return this.loading;
        },

        ...mapState(stores.ComplianceProfile, ['CNAMCallerProfile', 'shakenStirProfile']),
        ...mapState(stores.CallingStore, ['showShakenStirDeleteModal']),
    },

    watch: {
        show(value) {
            if (value) {
                this.init();
            }
        },
    },

    methods: {
        async init() {
            this.loading = true;

            await this.fetchShakenStirProfile();

            this.loading = false;
        },

        async fetchShakenStirProfile() {
            try {
                await this.$store.dispatch('fetchShakenStirProfile');
            } catch (e) {
                console.log(e);
            }
        },

        handleClosed() {
            this.$store.dispatch('handleShowShakenStirDeleteModal', false);
            this.$emit('closed', false);
        },

        async handleSubmit() {
            try {
                this.busy = true;

                const id = this.shakenStirProfile.businessProfile.id;

                if (!id) {
                    this.busy = false;
                    return;
                }

                await this.$store.dispatch('deleteShakenStirProfile', id);

                if (!this.CNAMCallerProfile.cnam.length && this.shakenStirProfile.hasStatusEmpty) {
                    await this.$store.dispatch('deleteComplianceSubscription');
                }
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleSubmit');
            } finally {
                this.busy = false;
                this.handleClosed();
            }
        },
    },
};
</script>
